var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-0 ma-0"},[_c('v-subheader',{staticClass:"mb-1 ml-0 pl-0",staticStyle:{"height":"auto"}},[_vm._v(" "+_vm._s(_vm.$t("room.illumination.preconditions"))+" ")]),_c('niko-textarea',{attrs:{"rows":1,"value":_vm.test.test_requirements,"placeholder":_vm.$t('room.illumination.preconditions')},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'test_requirements',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
      }}}),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.illuminance.title")))]),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.illuminance.required'),"min":0,"max":1500,"suffix":"lux","step":"1","value":_vm.test.average_illuminance},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'average_illuminance',
          newValue: value,
        };

        _vm.changeIlluminationTestAttribute(options);
      }}}),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.illuminance.deviation'),"subLabel":_vm.$t('room.illumination.illuminance.deviation_info'),"min":0,"max":100,"suffix":"%","step":"1","value":_vm.test.illuminance_deviation},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'illuminance_deviation',
          newValue: value,
        };

        _vm.changeIlluminationTestAttribute(options);
      }}}),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.uniformity.title")))]),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.uniformity.required'),"min":0,"max":1,"suffix":"U0","step":"0.1","accuracy":0.1,"value":_vm.test.uniformity,"textFieldType":"text"},on:{"onChange":function (valueObj) {
        var options = {
          index: _vm.index,
          attribute: 'uniformity',
          newValue: Math.round(valueObj.value * 10) / 10,
        };
        _vm.changeIlluminationTestAttribute(options);
      }}}),_c('v-btn',{staticClass:"mb-6",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteIlluminationTest(_vm.index)}}},[_c('v-icon',[_vm._v("$iconDelete")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }